// extracted by mini-css-extract-plugin
module.exports = {"dateItem":"EventCalendar_dateItem__aFI3w"};